import * as React from 'react';
import DropdownInput from '../components/DropdownInput';
import { noWhiteSpace } from '../GlobalFunctions';

interface Props {
  name: string;
  defaultValue?: string;
  isGradeLevelLocked?: boolean;
  label?: string;
}

const salutationValues = ['', 'Ms', 'Mrs', 'Mr', 'Dr', 'Ind', 'Mx', 'Misc'];

export const SalutationDropdown = ({ name, defaultValue }: Props): JSX.Element => {
  return (
    <DropdownInput defaultValue={defaultValue} label='Salutation' name={name}>
      {salutationValues.map((x: string, index) => (
        <option value={x} key={x}>
          {salutationValues[index]}
        </option>
      ))}
    </DropdownInput>
  );
};

const roleOptions = [
  'Teacher',
  'Principal',
  'District Administrator',
  'School Administrator',
  'Librarian',
  'Counselor',
  'SEL or PBIS Lead',
  'Homeschool Teacher',
  'Parent',
  'Other',
];
const roleValues = [
  'Teacher',
  'Principal',
  'District Administrator',
  'School Administrator',
  'Librarian',
  'Counselor',
  'Social Emotional Learning Lead',
  'Homeschool Teacher',
  'Parent',
  'Other',
];

export const RoleDropdown = ({ name, defaultValue, label }: Props): JSX.Element => {
  return (
    <DropdownInput defaultValue={defaultValue} label={label} name={name}>
      <option value='none' disabled>
        Select your educational role
      </option>
      {roleValues.map((x: string, index) => (
        <option value={x} key={x}>
          {roleOptions[index]}
        </option>
      ))}
    </DropdownInput>
  );
};

const gradeOptions = [
  'Pre-Kindergarten',
  'Kindergarten',
  '1st Grade',
  '2nd Grade',
  '3rd Grade',
  '4th Grade',
  '5th Grade',
  '6th Grade',
  '7th Grade',
  '8th Grade',
  '9th Grade',
  '10th Grade',
  '11th Grade',
  '12th Grade',
];

const gradeValues = ['-1', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

const hintText = noWhiteSpace`BASIC account users can only access one grade level of lesson materials. Please use
the Upgrade button at the top to find out how to upgrade your account.`;

export const GradeDropdown = ({ name, defaultValue, isGradeLevelLocked }: Props): JSX.Element => {
  return (
    <>
      <DropdownInput
        defaultValue={defaultValue}
        disabled={isGradeLevelLocked}
        label='Grade'
        name={name}
        hintIcon={isGradeLevelLocked}
        hintText={hintText}
      >
        <option value='none' disabled>
          Select your classroom grade
        </option>
        {gradeValues.map((x: string, index) => (
          <option value={x} key={x}>
            {gradeOptions[index]}
          </option>
        ))}
      </DropdownInput>
    </>
  );
};
